// External Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from 'material-ui-next/Avatar';
import Chip from 'material-ui-next/Chip';
import DatePicker from 'material-ui/DatePicker';
import { DialogContent } from 'material-ui-next/Dialog';
import Input from 'material-ui-next/Input';
import { ListItemText } from 'material-ui-next/List';
import { MenuItem } from 'material-ui-next/Menu';
import Select from 'material-ui-next/Select';
import Subheader from 'material-ui/Subheader';
import TextField from 'material-ui-next/TextField';

// Internal Dependencies
import connectComponent from '../../../connect-component';
import { updateNinjaForm } from '../../../state/ui/update-ninjas/add-ninja-dialog/actions';

// Local Variables
const propTypes = {
  badges: PropTypes.arrayOf(PropTypes.object),
  coderBadges: PropTypes.arrayOf(PropTypes.object),
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  title: PropTypes.string,
  updateForm: PropTypes.func,
};

const defaultProps = {
  badges: [],
  coderBadges: [],
  firstName: '',
  lastName: '',
  title: '',
  updateForm: null,
};

const menuStyles = {
  PaperProps: {
    style: {
      maxHeight: 300,
      width: 300,
    },
  },
};

const rowStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  paddingTop: 24,
};

const rowStyles3 = {
  display: 'flex',
  flexDirection: 'column',
};

const textFieldStyles = {
  marginRight: 24,
};

const datePickerStyles = {
  width: '100%',
  paddingTop: 10,
};

const chipStyles = {
  margin: 4,
};

const chipDivStyles = {
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  marginTop: 16,
};

const selectedStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  marginRight: 2,
};

const subheaderStyles = {
  paddingLeft: 0,
};

const listItemStyles = {
  paddingTop: 10,
};

const avatarStyles = {
  width: 45,
  height: 45,
  paddingLeft: 0,
};

class NinjaInfoForm extends Component {

  state = {
    badgesSelected: ['Select Badges'],
  };

  render() {
    const {
      badges,
      coderBadges,
      firstName,
      lastName,
      title,
      updateForm,
    } = this.props;

    const coderBadgeKeys = coderBadges.map(badge => badge.badgeKey);
    const isDisabled = key => coderBadgeKeys.includes(key);

    const updateBadgeKeys = (event) => {
      event.stopPropagation();
      this.setState({ badgesSelected: event.target.value });
      let modifiedCoderBadges = [];
      const index = event.target.value;

      const newBadge = {};
      newBadge.badgeKey = Number(index);
      newBadge.date = new Date().toString();
      modifiedCoderBadges = modifiedCoderBadges.concat(coderBadges, newBadge);

      updateForm({ coderBadges: modifiedCoderBadges });
    };

    const renderSelects = () => {
      if (!badges) return null;
      return badges.map((badge, index) => (
        <MenuItem
          key={index}
          value={index}
          disabled={isDisabled(index)}
        >
          <div style={selectedStyles}>
            <Avatar src={`${window.location.pathname}images/badges/${badge.image}`} />
            <div style={listItemStyles}>
              <ListItemText primary={badge.name} />
            </div>
          </div>
        </MenuItem>
      ));
    };

    const renderSelect = (
      <Select
        value={this.state.badgesSelected}
        autoWidth
        onChange={event => updateBadgeKeys(event)}
        input={<Input id="select-multiple" />}
        fullWidth
        MenuProps={menuStyles}
      >
        <MenuItem selected value="">
          <em>None</em>
        </MenuItem>
        {renderSelects()}
      </Select>
    );

    const renderBadges = (
      Object.keys(coderBadges).map((badge, index) => {
        const image = `${window.location.pathname}images/badges/${badges[coderBadges[index].badgeKey].image}`;
        const badgeName = badges[coderBadges[index].badgeKey].name;
        return (
          <Chip
            key={index}
            avatar={<Avatar src={image} style={avatarStyles} />}
            label={badgeName}
            style={chipStyles}
          />
        );
      })
    );

    const renderForm = (
      <DialogContent>
        <div style={rowStyles}>
          <TextField
            required
            id={firstName}
            label="First Name"
            placeholder="Jhon"
            fullWidth
            style={textFieldStyles}
            value={firstName}
            onChange={e => updateForm({ firstName: e.target.value })}
          />
          <TextField
            required
            id={lastName}
            label="Last Name"
            placeholder="Doe"
            fullWidth
            value={lastName}
            onChange={e => updateForm({ lastName: e.target.value })}
          />
        </div>
        <div style={rowStyles}>
          <TextField
            required
            id={title}
            label="Title"
            placeholder="Html Ninja"
            fullWidth
            style={textFieldStyles}
            value={title}
            onChange={e => updateForm({ title: e.target.value })}
          />
          <DatePicker
            autoOk
            // defaultDate={todaysDate}
            hintText="Attendance"
            style={datePickerStyles}
            fullWidth
          />
        </div>
        <div style={rowStyles3}>
          <Subheader
            inset
            style={subheaderStyles}
          >
            Select badges
          </Subheader>
          {renderSelect}
        </div>
        <div style={chipDivStyles}>
          {renderBadges}
        </div>
      </DialogContent>
    );

    return (
      <div>
        {renderForm}
      </div>
    );
  }
}

NinjaInfoForm.propTypes = propTypes;
NinjaInfoForm.defaultProps = defaultProps;

export default connectComponent((state) => {
  const { badges, ui } = state;
  const {
    coderBadges,
    firstName,
    lastName,
    title,
  } = ui.updateNinjas.ninjaDialog.form;
  return {
    badges,
    coderBadges,
    firstName,
    lastName,
    title,
  };
}, {
  updateForm: updateNinjaForm,
}, NinjaInfoForm);



/** WEBPACK FOOTER **
 ** ./src/dashboard/update-ninjas/update-ninjas-dialog/ninja-info-form.js
 **/